import { TableColumn } from "./dataInterface";

export const accountRunkingTableColumn: TableColumn = {
  title: "ランキング一覧",
  detail: false,
  detailTitle: "エントリー詳細",
  detailColumn: "詳細",
  detailKey: ["id"],
  addTitle: "ランキング登録",
  editAuth: [],
  tableFunction: [],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "runking_day",
      name: "表示範囲",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "",
      sort: false,
      tableValue: null,
      serch: true,
      serchType: "runking_day",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "120px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_company_name",
      name: "パートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "authority",
      name: "権限",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "130px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_company_group_name",
      name: "グループ",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "130px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "group",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_account_name",
      name: "アカウント",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "130px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "sale_account",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_number",
      name: "トスアップ数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "110px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_valid_appoint_number",
      name: "トスアップ-有効アポ数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "175px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_pre_check_ok_number",
      name: "トスアップ-前確OK数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "165px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_pre_check_ok_rate",
      name: "トスアップ-前確OK率",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "165px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_open_number",
      name: "トスアップ-開通数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "145px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_closing_appoint_number",
      name: "クロージング-有効アポ数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "190px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_closing_success_number",
      name: "クロージング-エントリー数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "200px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_closing_success_rate",
      name: "クロージング-エントリー率",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "200px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "toss_up_closing_success_open_number",
      name: "クロージング-開通数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "160px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_number_shot",
      name: "エントリー数-ショット",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "175px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_shot_open_number",
      name: "エントリー-ショット-開通数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "205px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_number_stack",
      name: "エントリー数-ストック",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "175px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_stack_open_number",
      name: "エントリー-ストック-開通数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "205px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    /*
    {
      key: "entry_opening_wait_number",
      name: "開通待ち",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "90px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_opening_number",
      name: "開通済",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "80px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "entry_opening_rate",
      name: "開通率",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "80px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    */
    {
      key: "entry_cancell_number",
      name: "解約数",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "80px",
      sort: true,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  subTable: [],
};
